/**
 * 上传相关接口
 */

import { post } from 'src/lib/http';
import { HttpPrefix } from 'src/lib/wemeet-http-moudle';
import axios, { CancelToken } from 'axios';

export type { CancelToken } from 'axios';

export interface GetTokenData {
  url: string;
  authorization: string;
  cos_id: string;
  post_authorization: string;
}

export interface GetVideoToken {
  bucket: string;
  bucket_url: string;
  key: string;
  region: string;
  session_token: string;
  start_time: string;
  expire_time: string;
  temp_secret_id: string;
  temp_secret_key: string;
}

export interface TokenPostData {
  content_type: string;
  feature: string;
}

export interface VideoToken {
  meeting_id?: string;
  business_id: string;
  doc_suffix: string;
}

export interface UploadPutData {
  url: string;
  authorization: string;
  file: File;
  onUploadProgress?: (data: any) => void;
  cancelToken?: CancelToken;
}

export interface TempUrlResData {
  download_url: string;
}

export interface TempUrlPostData {
  cos_id: string;
  feature: string;
  image_type: string;
  check_type: string;
}

// 获取上传token
export const getVideoUploadToken = (postData: VideoToken) => {
  const path = '/v2/activities/upload/get-common-upload-temp-key';
  return new Promise<GetVideoToken>((resolve, reject) => {
    post(HttpPrefix.WEMEET_TAPI, path, postData).then(
      (res) => {
        const { code, data, msg } = res;
        if (code === 0) {
          if (data.major !== null) {
            resolve(data.major);
          }
        } else {
          reject(msg);
        }
      },
      (e) => {
        reject(e);
      },
    );
  });
};

export const getUploadToken = (postData: TokenPostData) => {
  const path = '/v2/activities/upload/get-common-upload-auth';
  return new Promise<GetTokenData>((resolve, reject) => {
    post(HttpPrefix.WEMEET_TAPI, path, postData).then(
      (res) => {
        const { code, data, msg } = res;
        if (code === 0) {
          resolve(data);
        } else {
          reject(msg);
        }
      },
      (e) => {
        reject(e);
      },
    );
  });
};

// 上传文件
export const uploadFile = (putData: UploadPutData) => {
  const { url, authorization, file, onUploadProgress, cancelToken } = putData;
  return new Promise((resolve, reject) => {
    axios
      .put(url, file, {
        headers: {
          authorization,
        },
        onUploadProgress,
        cancelToken,
      })
      .then(
        (res) => {
          resolve(res);
        },
        (err) => {
          // put方式上传失败上报错误
          const msg = `COS_UPLOAD Request Error: [url]: ${url}, [data]: ${JSON.stringify(
            putData,
          )}, [error info]: ${err}`;
          window.nextAegis.report(msg, err);
          window.nextAegis.reportEvent(`ServerError_${url}`);
          reject(err);
        },
      );
  });
};

// 获取图片临时链接
export const getTempUrl = (postData: TempUrlPostData) => {
  const path = '/v2/activities/public/upload/get-tmp-url';
  return new Promise<string>((resolve, reject) => {
    post(HttpPrefix.WEMEET_TAPI, path, postData).then(
      (res) => {
        const { code, data, msg } = res;
        if (code === 0) {
          resolve(data.download_url);
        } else {
          reject(msg);
        }
      },
      (e) => {
        reject(e);
      },
    );
  });
};
